import Swal from 'sweetalert2';

import { settings } from 'settings';
import Fetch from 'utils/fetch';
import { AreaRating } from '../const/AreaRating';

export interface ZoneRatingEditJson {
  courierId: number;
  zoneId: string;
  newRating: AreaRating | undefined;
}

export interface ZoneRatingJson {
  courierId: number;
  zoneId: string;
  rating: AreaRating;
}

function showErrorMessage(message: string): void {
  Swal.fire({
    position: 'center',
    icon: 'error',
    title: 'There was an error',
    showConfirmButton: false,
    timer: 2500,
    html: message,
  });
}

export async function fetchRatings(
  courierId: number
): Promise<ZoneRatingJson[]> {
  try {
    const response: Response = await Fetch.post({
      url: `${settings.autobundlerUrl}/api/zones/ratings`,
      body: { courierIds: [courierId] },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch ratings');
    }
    return await response.json();
  } catch (e) {
    showErrorMessage(
      `<div>Failed to fetch ratings for courier with id: ${courierId}.</div>`
    );
    console.error('Error fetching ratings', e);

    return [];
  }
}

export async function fetchAllRatings(
  courierIds: string[]
): Promise<ZoneRatingJson[]> {
  try {
    const response: Response = await Fetch.post({
      url: `${settings.autobundlerUrl}/api/zones/ratings`,
      body: { courierIds },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch ratings');
    }
    return await response.json();
  } catch (e) {
    showErrorMessage(`<div>Failed to fetch zone ratings for couriers.</div>`);
    console.error('Error fetching ratings', e);

    return [];
  }
}

export async function updateRatings(
  rating: ZoneRatingEditJson
): Promise<Response> {
  const response: Response = await Fetch.post({
    url: `${settings.autobundlerUrl}/api/zones/ratings/edit`,
    body: rating,
  });

  if (!response.ok) {
    showErrorMessage(
      `<div>Failed to update rating for zone: ${rating.zoneId} for courier: ${rating.courierId}</div>`
    );
    console.error('Error updating ratings', response.statusText);
    throw new Error('Failed to update rating');
  }

  return response;
}
